import { Component, OnInit, AfterViewInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { LeaderboardService } from '../../../../core';

@Component({
  selector: 'app-leaderboard-distributor',
  templateUrl: './leaderboard-distributor.component.html',
  styleUrls: ['./leaderboard-distributor.component.scss']
})
export class LeaderboardDistributorComponent implements OnInit, AfterViewInit {

  @Input() userData: any;

  @ViewChild('positionTemplate') positionTemplate!: TemplateRef<any>;

  columns: any[] = [];
  page: number = 1;
  pageNo: number = 0;
  size: number = 5;
  isLoading: boolean = false;
  quaterListArray: any;
  selectedDistQtr: any;
  data: any;

  constructor(private leaderboardService: LeaderboardService) { }

  ngOnInit() {
    this.getQuaterList();
  }

  ngAfterViewInit() {
    setTimeout(() => { this.initializeColumns(); });
  }

  initializeColumns() {
    const positionCol: any = { field: 'position', header: 'Position' };
    if (this.positionTemplate) { positionCol.cellTemplate = this.positionTemplate; }

    this.columns = [
      { field: 'rank', header: 'Rank', align: 'center', isBold: true },
      { field: 'participant', header: 'Participant' },
      positionCol,
      { field: 'region', header: 'Region' }
    ];
  }

  getQuaterList() {
    const req = 'includeCurrentQuarter=true&noOfPreviousQuarters=3';
    this.leaderboardService.getquaterListForDistributorChgFlag(req).subscribe((data: any) => {
      this.selectedDistQtr = data[0];
      this.fetchData(data[0]);
      this.quaterListArray = data;
    });
  }

  onChangeQuater(val: any) {
    this.size = 5;
    this.pageNo = 0;
    this.page = 1;
    this.data = '';
    this.selectedDistQtr = val;
    this.fetchData(val);
  }

  fetchData(val: any) {
    const req = '?fiscalQuarter=' + val.fiscalQuarter
      + '&fiscalYear=' + val.fiscalYear
      + '&size=' + this.size
      + '&page=' + this.pageNo;
    this.isLoading = true;
    this.leaderboardService.getdistiChallengeRequest(req).subscribe((data: any) => {
      this.isLoading = false;
      this.data = data;
    });
  }

  onPageChange(newPage: number) {
    this.page = newPage;
    this.pageNo = newPage - 1;
    const req = '?fiscalQuarter=' + this.selectedDistQtr.fiscalQuarter
      + '&fiscalYear=' + this.selectedDistQtr.fiscalYear
      + '&size=' + this.size
      + '&page=' + this.pageNo;
    this.isLoading = true;
    this.leaderboardService.getdistiChallengeRequest(req).subscribe((data: any) => {
      this.isLoading = false;
      this.data = data;
    });
  }
}
